// 状态码常量
export const STATUS = {
  CONTINUE: 100,
  SWITCHING_PROTOCOLS: 101,
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NON_AUTHORITATIVE_INFORMATION: 203,
  NO_CONTENT: 204,
  RESET_CONTENT: 205,
  PARTIAL_CONTENT: 206,
  MULTI_STATUS: 207,
  MULTIPLE_CHOICES: 300,
  MOVED_PERMANENTLY: 301,
  FOUND: 302,
  SEE_OTHER: 303,
  NOT_MODIFIED: 304,
  USE_PROXY: 305,
  RESERVED: 306,
  TEMPORARY_REDIRECT: 307,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  PAYMENT_REQUIRED: 402,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  NOT_ACCEPTABLE: 406,
  PROXY_AUTHENTICATION_REQUIRED: 407,
  REQUEST_TIMEOUT: 408,
  CONFLICT: 409,
  GONE: 410,
  LENGTH_REQUIRED: 411,
  PRECONDITION_FAILED: 412,
  REQUEST_ENTITY_TOO_LARGE: 413,
  REQUEST_URI_TOO_LONG: 414,
  UNSUPPORTED_MEDIA_TYPE: 415,
  REQUESTED_RANGE_NOT_SATISFIABLE: 416,
  EXPECTATION_FAILED: 417,
  UNPROCESSABLE_ENTITY: 422,
  LOCKED: 423,
  FAILED_DEPENDENCY: 424,
  PRECONDITION_REQUIRED: 428,
  TOO_MANY_REQUESTS: 429,
  REQUEST_HEADER_FIELDS_TOO_LARGE: 431,
  UNAVAILABLE_FOR_LEGAL_REASONS: 451,
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
  HTTP_VERSION_NOT_SUPPORTED: 505,
  INSUFFICIENT_STORAGE: 507,
  NETWORK_AUTHENTICATION_REQUIRED: 511
}

// 内部错误码解释
export const CODE = {
  10000: '未知错误',
  10001: '数据错误',
  10002: '唯一性错误',
  10003: '空数据错误',
  10004: '请求头内设置X-Csrf-Token头',
  10005: '请先登录',
  10006: '需要超级管理员才能访问',
  10007: '没有该接口权限',
  10008: '请先通过验证码校验',
  10009: '请先通过手机验证码校验',
  10010: '已超时，请稍等片刻再操作',
  10011: '已超过接口访问次数',
  10012: '频繁操作，请稍等片刻再操作',
  10013: '当前的资源已经被禁用',
  10014: '帐号或密码错误',
  10015: '当前账号正在审核中, 请稍后登录',
  10016: '用户不存在',
  10017: '邮箱不可为社会邮箱',
  10018: '不能为常见密码',
  10019: '密码校验错误',
  10020: '错误的JWT, 无法解析',
  10021: '操作已经完成, 请不要重复操作',
  10022: '验证码错误',
  10025: '非法请求'
  // csrf: '请求头内设置X-Csrf-Token头',
  // 'view-permission': '没有该接口权限',
  // application: '应用验证错误',
  // 'wrong-application': '应用匹配错误',
  // captcha: '请点击按钮进行验证',
  // user: '用户鉴权错误',
  // 'no-data': '空数据错误',
  // unique: '唯一性错误',
  // '10014': '帐号或密码出错',
  // 'registering':'用户账号审核中，请稍后登录',
  // 'secret-key' :'原始密码输入不正确',
  // 'user-does-not-exist' : '未注册用户账号',
  // 'times-limit': '频繁登录，请稍等再登录',
  // phone:'手机验证错误',
  // superuser:'用户鉴权错误',
  // duplicated:'重复错误',
  // 'common-email':'邮箱必须为公司邮箱',
  // 'no-active':'需要超级管理员才能访问',
  // 'timeout':'已超时，请稍等片刻再操作'
}
// 内部错误码解释
export const DATA = {
  label: '邮箱',
  password: '密码',
  new_password: '新密码',
  phone: '手机号',
  company: '公司名称',
  email: '邮箱',
  username: '用户名',
  user_id: '业务名',
  keyword: '关键词',
  name: '产品名称'
}

// 超级管理员的权限名
export const SUPERUSER_PERMISSION = '*'

// 腾讯验证码id
export const APP_ID = '2059457950'

// 分页参数名称
export const PAGE_VAR = 'page'

// 分页条目数参数名称
export const PAGE_SIZE_VAR = 'pageSize'

// 支持的分页条目数
export const PAGE_SIZES = [10, 20, 50, 100]

// 默认分页条目数
export const DEFAULT_PAGE_SIZE = 10

// 权限类型
export const PERMISSION_TYPES = { view: '接口', row: '记录', col: '字段', other: '其他' }

// 官网正式环境域名
const hostArr = ['ww.threathunter.cn', 'localhost:8080']

// 不同场景验证码APPID
export const isPro = hostArr.includes(location.host)

export const APP_ID_MAP = isPro ? {
  LOGIN: '2027733727',
  PHONE: '2025989083',
  PASSWORD_FORGET: '2023714416'
} : {
  LOGIN: '2090570326',
  PHONE: '2058416655',
  PASSWORD_FORGET: '2014236796'
}

// 验证码对应接口
export const CAPTCHA_API_NAMES = {
  REGISTER: 'phone-captcha',
  LOGIN: 'user-login',
  PASSWORD_FORGET: 'user-password-forget',
  PASSWORD_REFRESH: 'user-password-refresh'
}
const CATEGORY_RISKLEVEL = [
  { value: null, label: '全部' },
  { value: 'high', label: '高' },
  { value: 'middle', label: '中' },
  { value: 'low', label: '低' }
]

export default {
  STATUS,
  SUPERUSER_PERMISSION,
  PAGE_SIZES,
  DEFAULT_PAGE_SIZE,
  PAGE_VAR,
  PAGE_SIZE_VAR,
  PERMISSION_TYPES,
  CAPTCHA_API_NAMES,
  APP_ID,
  CATEGORY_RISKLEVEL,
  APP_ID_MAP
}
